import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';
// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import { StyledChart } from './components/chart';
import ScrollToTop from './components/scroll-to-top';
import { glb_sv, socket_sv } from './utils';
import './scss/style.scss';
import crypt from './utils/service/crypt';
import { useEffect } from 'react';
// ----------------------------------------------------------------------
setTimeout(() => {
    socket_sv.setNewConnection();
    glb_sv.setClient_tp();
}, 500);

export default function App() {
    useEffect(() => {
        const userData = sessionStorage.getItem('proc_data');
        const menu = sessionStorage.getItem('menu');

        if (userData && menu) {
            try {
                const data = JSON.parse(crypt.deCode(userData));
                glb_sv.userInfo = data;
                glb_sv.menu = JSON.parse(crypt.deCode(menu));
                glb_sv.sessionInfo.comp_id = data.o_3;
                glb_sv.sessionInfo.branch_id = data.o_4;
                glb_sv.sessionInfo.user_id = data.id;
            } catch (error) {}
        }
    }, []);

    // if (process.env.NODE_ENV === 'production') {
    //     console.log = function () {};
    //     console.debug = function () {};
    //     console.info = function () {};
    //     console.warn = function () {}; // có thể giữ lại cảnh báo
    // }
    return (
        <HelmetProvider>
            <BrowserRouter>
                <ThemeProvider>
                    <ScrollToTop />
                    <StyledChart /> <Router />
                    {/* Custom react-toastify */}
                    <ToastContainer
                        position="top-right"
                        autoClose={800}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="colored"
                    />
                </ThemeProvider>
            </BrowserRouter>
        </HelmetProvider>
    );
}
